import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import SEOHead from "../../components/feature/SEOHead";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import DashboardSection from "./components/DashboardSection";
import StatsSection from "./components/StatsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";

const SITE_URL = import.meta.env.VITE_SITE_URL ?? "https://trackly.app";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "name": "Trackly",
      "url": SITE_URL,
      "description": "Profit tracker for sports card flippers and resellers. Know your real margins on every flip.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${SITE_URL}/showcase?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "SoftwareApplication",
      "name": "Trackly",
      "description": "Profit and margin tracker for sports card flippers and resellers. Automatically calculates true net profit, ROI, and hidden fees on every flip.",
      "applicationCategory": "FinanceApplication",
      "operatingSystem": "Web",
      "url": SITE_URL,
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
      },
    },
  ],
};

export default function Home() {
  return (
    <div className="bg-[#050505] min-h-screen">
      <SEOHead
        title="Trackly | Know Your Real Margins — Profit Tracker for Flippers"
        description="Trackly is the simple profit tracker for sports card flippers and resellers. Calculate true net profit and ROI on every flip by automatically accounting for platform fees, shipping, and hidden costs."
        keywords="profit tracker for flippers, sports card profit calculator, eBay fee calculator, flip ROI, reseller margin tool"
        canonical={SITE_URL}
        ogTitle="Trackly | Know Your Real Margins on Every Flip"
        ogDescription="Most flippers lose 15–22% to hidden fees. Trackly calculates true net profit and ROI on every flip automatically. No spreadsheets. No guessing."
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <FeaturesSection />
        <DashboardSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
